import { render, staticRenderFns } from "./BaySingle.vue?vue&type=template&id=2f94b4f9&scoped=true"
import script from "./BaySingle.vue?vue&type=script&lang=ts"
export * from "./BaySingle.vue?vue&type=script&lang=ts"
import style0 from "./BaySingle.vue?vue&type=style&index=0&id=2f94b4f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94b4f9",
  null
  
)

export default component.exports